import React, { useEffect, useState } from "react";
import styles from "./ScrollToTopButton.module.scss";
import { IconScrollToTop } from "icons";
import { useDispatch } from "react-redux";
import packageJson from "../../../../package.json";

export const ScrollToTopButton = () => {
  const { version } = packageJson;
  const dispatch = useDispatch();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setIsScrolled(offset > 120);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [dispatch, version]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!isScrolled) {
    return null;
  }

  return (
    <button onClick={scrollToTop} className={styles.scrollToTopButton}>
      <IconScrollToTop />
    </button>
  );
};
